export default __webpack_public_path__ + "static/waxpiercingdust-9befd798ffc72886c3c5d739f111ae05.png";